<template>
    <div class="tool_container" id="tool_container">
        <div class="panelcontainer_for_tool">
            <table class="params">
                <tbody>
                    <!-- 1 省份： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="province">省 份：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select class="select_for_tool" id="province"
                                    @change="setCityList($event), selectLocation($event, selectedData, 'province')">
                                    <option v-for="(item, index) in localData" :key="index" :value="item.province">
                                        {{ item.province }}</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 2 县市： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="city">县 市：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select class="select_for_tool" id="city"
                                    @change="selectLocation($event, selectedData, 'city')">
                                    <option v-for="(item, index) in cityList" :key="index" :value="item">{{
                                        item }}</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 3 风压重现期： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="recurrence_wind">风压重现期(年)：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <input type="number" v-model.number="selectedData.recurrence_wind" id="recurrence_wind"
                                    @keydown="filterNum($event)" @change="checkNum($event)" />
                            </div>
                        </td>
                    </tr>
                    <!-- 4 雪压重现期： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="recurrence_snow">雪压重现期(年)：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <input type="number" v-model.number="selectedData.recurrence_snow" id="recurrence_snow"
                                    @keydown="filterNum($event)" @change="checkNum($event)" />
                            </div>
                        </td>
                    </tr>
                    <!-- 5 0.3控制： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="recurrence_snow">风压控制≥0.3kN/m<SUP>2</SUP>：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <select id="wind_mincontrol" class="select_for_tool"
                                    @change="setValue($event, selectedData, 'wind_mincontrol')">
                                    <option value="1" selected>是</option>
                                    <option value="0">否</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <!-- 6  风荷载敏感放大： -->
                    <tr>
                        <td class="label_for_tool">
                            <label class="text_label" for="wind_amplification">风荷载敏感放大系数：</label>
                        </td>
                        <td class="text_for_tool">
                            <div class="panel_for_tool">
                                <input type="number" v-model.number="selectedData.wind_amplification"
                                    id="wind_amplification" @keydown="filterNum($event)" @change="checkNum($event)" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="content_for_tool">
            <div class="result_container">
                <div class="result_title">
                    <h4>查询结果:</h4>
                </div>
                <div class="result_content">
                    <table class="result_table">
                        <!-- 3 风压重现期： -->
                        <tbody>
                            <tr>
                                <td class="result_td">
                                    <span>基本风压(kN/m<SUP>2</SUP>)：</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[0] }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="result_td">
                                    <span>基本雪压(kN/m<SUP>2</SUP>)：</span>
                                </td>
                                <td class="result_td result_td_right">
                                    <span>{{ result[1] }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="tips">
                    <p class="tips_text">注:1、根据《建筑结构荷载规范》(GB50009-2012)编制。</p>
                    <p class="tips_text">&ensp;&ensp;&ensp;2、风压控制和风荷载敏感放大系数为规范8.1.2的要求。</p>
                    <p class="tips_text">&ensp;&ensp;&ensp;3、雪荷载敏感的结构，应采用100年重现期的雪压(荷范7.1.2)。</p>
                    <p class="tips_text">&ensp;&ensp;&ensp;4、规范表E5错误之处：广西：龙舟应为龙州；四川：理唐应为理塘；</p>
                    <p class="tips_text">&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;云南屏边风压100年为0.35，小于50年的0.4，错误，本表50年</p>
                    <p class="tips_text">&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;的风压按0.3取值。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Wind_Snow"
};
</script>

<script setup>
import { _getWindSnowLocal, _getWindSnowValue } from "@/api/index";
import { reactive, watch } from "vue";
// import { useTempStore } from '@/store/temp';
import Toast from "@/utils/toast";
import { filterNum, checkNum } from "@/utils/number_input.js";
// import { filterNum, checkNum } from "@/utils/number.js";

// 01加载地点数据~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
var localData = reactive([]);
var cityList = reactive([]); // 加载完localData后，默认选择第一个省份的城市数据,后面调用setCityList函数更新

_getWindSnowLocal().then(
    (res) => {
        if (res.data.message === "ok") {
            let len = res.data.data.location.length;
            for (let i = 0; i < len; i++) {
                let province = res.data.data.location[i].province;
                let city = res.data.data.location[i].city;
                let selected = res.data.data.location[i].selected;
                let obj = {
                    province: province,
                    "selected": selected,
                    city: city,
                };
                localData.push(obj);
            }
            setCityList(0); // 默认选择第一个省份的城市数据
        }
    }
)



// 02提交的查询参数~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
let selectedData = reactive(
    {
        province: 0,
        city: 0,
        recurrence_wind: 50,
        recurrence_snow: 50,
        wind_mincontrol: 1,
        wind_amplification: 1.0,
    }
);

// 03查询结果~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
let result = reactive([0.45, 0.4,]);

watch(selectedData,
    (newVal, oldVal) => {
        if (newVal.recurrence_wind == '' || newVal.recurrence_snow == '' || newVal.wind_amplification == '') {
            Toast('参数不能为空！', 'tool_container', 50, 1000, true);
        } else if (newVal.recurrence_wind < 10 || newVal.recurrence_snow < 10) {
            Toast('重现期不能小于10年！', 'tool_container', 50, 1000, true);
        } else if (newVal.wind_amplification < 1) {
            Toast('风荷载敏感放大系数不能小于1！', 'tool_container', 50, 1000, true);
        } else {
            _getWindSnowValue(selectedData).then(
                (res) => {
                    if (res.data.message === "ok") {
                        result[0] = res.data.data.wind_pressure;
                        result[1] = res.data.data.snow_pressure;
                    } else {
                        Toast(res.data.message, 'tool_container', 50, 1000, true);
                    }
                }
            ).catch(
                (err) => {
                    // console.log(err);
                    Toast('warning, 查询失败！', 'tool_container', 50, 1000, true)
                }
            )
        }
    }
)


//公共函数~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function selectLocation(e, obj, key) {
    let select = e.target;
    let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
    obj[key] = i;
}

// 设置城市列表~
function setCityList(index_or_event) {
    let index = 0;
    if (typeof index_or_event === "number" && !isNaN(index_or_event)) {
        index = index_or_event;
    } else if (typeof index_or_event === "object") {
        index = index_or_event.target.selectedIndex;
    }
    let city = localData[index].city;
    cityList.splice(0, cityList.length); // cityList = localData[index].city;会失去响应式
    for (let i = 0; i < city.length; i++) {
        cityList.push(city[i]);
    }
    selectedData.city = 0; // 默认选择第一个城市

    let select = document.getElementById('city');
    select.selectedIndex = 0; // 默认选择第一个城市的同时，下拉框也要更新为0
}

// selected改变SET的值
function setValue(e, obj, key) {
    let select = e.target;
    let i = select.selectedIndex; // selectedIndex代表的是你所选中项的index。
    let value = select.options[i].value;
    obj[key] = value;
}





</script>



<style scoped>
/* panel区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.tool_container {
    background-color: white;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    /* flex-direction: column; */

    /* align-items: center; */
    /* position: relative; */
    opacity: 0.7;
    overflow-y: scroll;
    scrollbar-width: none;
}

/* .tool_container::-webkit-scrollbar {
    display: none;
} */

.panelcontainer_for_tool {
    /* width: 375px; */
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

table {
    table-layout: fixed;
    padding: 0;
    width: 100% !important;
}

table .label_for_tool {
    width: 160px;
}

table .text_for_tool {
    width: 220px;
}

/* table tr {
    width: 100%;
} */

table tr td {
    padding: 0;

}

label {
    padding: 0 !important;
    margin-top: 21px;
    font-size: 15px;
}

.panel_for_tool {
    height: 40px;
    width: 220px;
    padding: 0px 20px;
    border: 1px solid var(--secondary-color);
    border-radius: 25px;
    margin-top: 20px;
    /* margin-bottom: 5px; */
    box-shadow: 6px 6px 3px rgba(0, 0, 0, 0.3), -4px -4px 4px rgba(194, 185, 185, 0.4);
    display: flex;
    justify-content: center;
}

.select_for_tool {
    width: 200px;
    height: 100%;
    border: none;
    outline: none;
    font-size: 14px;
    background-color: white;
    padding-top: 2px;
}


input[type="number"],
input[type="text"] {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    background-color: white;
    text-align: center;
    /* ime-mode: disabled; */
}

/* content区内的样式～～～～～～～～～～～～～～～～～～～～～～～～～～～ */
.content_for_tool {
    width: 100%;
    height: 250px;
    /* position: relative; */
    /* height: calc(100%); */
    /* overflow: auto; */
    /* margin-top: 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    color: black !important;
}

.result_container {
    width: 400px;
    margin-bottom: 10px;

}

.result_table {
    margin-top: 3px;
    width: 300px;
    border-collapse: collapse;
}

.result_table td {
    border: 1px solid var(--secondary-color);
    width: 50%;
    padding: 5px;
    font-size: 16px;
}

.result_td_right {
    font-size: 18px !important;
    line-height: 20px;
}

.tips {
    font-size: 12px;
    text-align: left;
}

.tips p {
    padding-bottom: 3px;
}
</style>
